module.exports = __webpack_public_path__ + "static/media/portal-novo.7741ec93.webp";